<script setup lang="ts">
import Flag from '../vectors/Flag.vue';
import ItemMenu from '../list-item/ItemMenu.vue';
import { countries, type CountryCode } from '@/utils-new/countryCode';

// TODO replace these temporary data later
const currentCountry = 'cs';

const TEMP_COUNTRIES_LIST: { code: CountryCode, label: string }[] = [
  { code: 'cs', label: 'Česká republika' },
  { code: 'at', label: 'Rakousko' },
  { code: 'ch', label: 'Švýcarsko' },
  { code: 'de', label: 'Německo' },
  { code: 'fr', label: 'Francie' },
  { code: 'hu', label: 'Maďarsko' },
  { code: 'it', label: 'Itálie' },
  { code: 'pl', label: 'Polsko' },
  { code: 'ro', label: 'Rumunsko' },
  { code: 'sk', label: 'Slovensko' }
];
</script>

<template>
  <div class="flex bg-white rounded-lg shadow w-70">
    <div class="flex flex-col rounded-lg overflow-hidden w-full">
      <template
        v-for="(value, index) in countries.filter(item => item.code !== currentCountry)"
        :key="index"
      >
        <ItemMenu
          :label="TEMP_COUNTRIES_LIST.find(tempItem => value.code === tempItem.code)?.label ?? value.code"
          :router-to="value.link"
        >
          <template #icon>
            <Flag
              :country="value.code"
              class="w-6"
            />
          </template>
        </ItemMenu>
        <hr
          v-if="index < countries.filter(item => item.code !== currentCountry).length - 1"
          class="border-brown-100"
        >
      </template>
    </div>
  </div>
</template>
